import axios from "axios";
import { useState } from "react";
import { IconButton } from "@mui/material";
import Helpful from "../../images/help.png";
import emptyHelp from "../../images/emphelp.png";
import information from "../../images/info.png";
import informationEmpty from "../../images/informnationEmpty.png";
import { useNavigate } from "react-router-dom";
const LikesCount = (props) => {
  const navigate = useNavigate();
  const [liked, setLiked] = useState(false);
  const [info, setInfo] = useState(false);
  const { post, baseUrl, token, width, forceUpdate } = props;
  const handleLikeClick = async (postId, likeType) => {
    const url = `${baseUrl}/api/post/like/${postId}`;
    axios
      .post(
        url,
        {
          likeType: likeType,
        },
        {
          headers: {
            authorization: token,
          },
        }
      )
      .then((res) => {
        forceUpdate();
        console.log("res.data", res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleLikes = () => {
    if (!token) {
      navigate("/usersignup");
    }
  };

  return (
    <div style={{ display: "flex", gap: width > 768 ? "66px" : "40px" }}>
      <div
        className="helpful-container"
        onClick={() => {
          handleLikes();
          handleLikeClick(post._id, "helpful");
          setLiked(!liked);
        }}
      >
        <div className="flex justify-center items-start">
          <div className="flex flex-col">
            {liked ? (
              <div className="relative">
                <IconButton>
                  <img
                    src={Helpful}
                    alt=""
                    title="Helpful"
                    style={{
                      height: width > 768 ? "30px" : "19px",
                      width: width > 768 ? "30px" : "19px",
                    }}
                  />
                </IconButton>
                <br />
                <span className="lg:text-xs md:text-xs text-[8px] absolute">
                  Helpful
                </span>
              </div>
            ) : (
              <div>
                <IconButton>
                  <img
                    src={emptyHelp}
                    alt=""
                    style={{
                      height: width > 768 ? "30px" : "19px",
                      width: width > 768 ? "30px" : "19px",
                    }}
                    title="Helpful"
                  />
                </IconButton>
                <br />
                <span className="lg:text-xs md:text-xs text-[8px] absolute">
                  Helpful
                </span>
              </div>
            )}
          </div>
          <h1 className="mt-3 lg:text-xs md:text-xs text-[8px]">
            {post?.likesCount?.helpful}
          </h1>
        </div>
      </div>

      <div
        className="informative-container"
        onClick={() => {
          handleLikes();
          handleLikeClick(post._id, "informative");
          setInfo(!info);
        }}
      >
        <div className="flex justify-center items-start">
          <div className="relative">
            {info ? (
              <div className="flex flex-col">
                <IconButton>
                  <img
                    src={information}
                    alt=""
                    style={{
                      height: width > 768 ? "30px" : "19px",
                      width: width > 768 ? "30px" : "19px",
                    }}
                    title="Informative"
                  />
                </IconButton>
                <span className="lg:text-xs md:text-xs text-[8px]">
                  Informative
                </span>
              </div>
            ) : (
              <div className="flex flex-col">
                <IconButton className="relative">
                  <img
                    src={informationEmpty}
                    style={{
                      height: width > 768 ? "30px" : "19px",
                      width: width > 768 ? "30px" : "19px",
                    }}
                    alt=""
                    title="Informative"
                  />
                </IconButton>
                <span className="lg:text-xs md:text-xs text-[8px]">
                  Informative
                </span>
              </div>
            )}
          </div>
          <h1 className="mt-3 lg:text-xs md:text-xs text-[8px]">
            {post?.likesCount?.informative}
          </h1>
        </div>
      </div>
    </div>
  );
};
export default LikesCount;
